import { render, staticRenderFns } from "./ExternalData.vue?vue&type=template&id=331548d0&"
import script from "./ExternalData.vue?vue&type=script&lang=js&"
export * from "./ExternalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports